/**
 * the buttons to press to switch between the different socialhubpopup tabs
 * txt: the text to show on the tab to show where it leads to, for example leaderboard
 */
import Sprite = PIXI.Sprite;
import { createPixiText, scaleToFit } from '../../../Utils/Utils';
import Rectangle = PIXI.Rectangle;

export class SocialTabBtn extends PIXI.Sprite {
    private activeTab: boolean; // bool if this tab is the active one
    public bgActive: PIXI.Sprite; // public to get the width of the button
    public tabKey: string;
    private text: PIXI.Text;
    private notification: PIXI.Sprite;

    constructor(txt: string) {
        super();

        const bg = new Sprite(PIXI.utils.TextureCache['mapui/leaderboard-tab-inactive']);
        bg.anchor.set(0.5);
        this.bgActive = new Sprite(PIXI.utils.TextureCache['mapui/leaderboard-tab-active']);
        this.bgActive.anchor.set(0.5);
        const text = createPixiText(
            txt,
            new Rectangle(0, 0, bg.width, bg.height),
            'Baloo',
            24,
            16,
            0xffffff
        );
        text.anchor.set(0.5);
        this.text = text;
        if (this.text.width > bg.width * 0.9) {
            this.text.scale.set(
                scaleToFit(this.text.width, this.text.height, bg.width * 0.9, bg.height * 0.9)
            );
        }
        this.notification = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/notification-badge']);
        this.notification.anchor.set(0.5);
        this.notification.x = bg.width * 0.4;
        this.notification.y = -bg.height * 0.2;
        this.notification.alpha = 0;
        this.addChild(bg, this.bgActive, text, this.notification);
        this.interactive = this.buttonMode = true;
        this.anchor.set(0.5);
        this.setActiveTab(false);
    }

    public setActiveTab(bool: boolean) {
        this.activeTab = bool;
        this.bgActive.alpha = this.activeTab ? 1 : 0;
        this.text.y = this.activeTab ? -this.bgActive.height * 0.1 : this.bgActive.height * 0.05;
        this.text.tint = this.activeTab ? 0xffffff : 0x84c5ff;
        if (this.activeTab) {
            this.hideNotification();
        }
    }

    public showNotification() {
        this.notification.alpha = 1;
    }

    public hideNotification() {
        this.notification.alpha = 0;
    }
}
